"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgEditPencilSquare = function SvgEditPencilSquare(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M798.44 960V553l63.876-61v468c0 18-6.155 33.167-18.464 45.5-12.31 12.333-27.446 18.5-45.411 18.5H63.875c-17.3 0-32.27-6.167-44.912-18.5C6.321 993.167 0 978 0 960V160c0-17.333 6.32-32.333 18.963-45 12.642-12.667 27.613-19 44.912-19h512l1.996 2-64.873 62H63.875v800h734.566zM973.1 41c16.634 16 29.11 32.333 37.426 49 8.317 16.667 12.809 34 13.474 52 0 17.333-3.992 34.667-11.977 52-7.984 17.333-20.293 34.667-36.927 52-7.32 8-33.601 34.333-78.846 79a89174.276 89174.276 0 01-145.716 143.5c-51.899 51-99.638 98.166-143.22 141.5-43.582 43.334-67.701 67.333-72.359 72a78.453 78.453 0 00-5.49 4 17.659 17.659 0 01-5.488 3c-7.985 2-24.286 7-48.905 15a7509.08 7509.08 0 01-76.85 24.5c-26.615 8.333-50.235 16-70.861 23-20.627 7-31.273 10.5-31.938 10.5-1.33 0-2.661.167-3.992.5-1.33.333-2.662.5-3.992.5-3.327 0-6.654-.667-9.98-2-3.328-1.333-6.322-3.333-8.983-6-3.327-3.333-5.656-7.5-6.987-12.5-1.33-5-1.33-9.833 0-14.5 0-.667 3.16-11.167 9.482-31.5 6.32-20.333 13.473-43.667 21.458-70a6151.554 6151.554 0 0022.955-77.5c7.32-25.333 12.642-43.333 15.969-54 .665-2 1.497-4 2.495-6s2.495-4 4.491-6l66.37-66.5c44.248-44.334 93.318-93.333 147.213-147 53.895-53.667 103.797-103.666 149.708-150 45.91-46.334 70.861-71.167 74.853-74.5 5.323-5.333 17.134-14.167 35.431-26.5C830.212 6.167 852.335 0 878.284 0c17.3 0 33.934 3.5 49.903 10.5 15.969 7 30.94 17.167 44.912 30.5zm-43.915 160c10.646-10.667 18.464-20.833 23.454-30.5 4.99-9.667 7.486-18.833 7.486-27.5-.666-8.667-3.493-17.667-8.484-27-4.99-9.333-12.475-18.667-22.456-28-8.65-8-17.133-14-25.45-18s-16.8-6-25.45-6c-14.639 0-27.447 4-38.425 12-10.979 8-17.134 12.667-18.464 14l-200.11 200.5A55138.194 55138.194 0 01478.567 433c-45.579 45.334-75.02 74.667-88.328 88-4.658 16.667-11.478 40.167-20.46 70.5a7806.264 7806.264 0 01-26.449 87.5 15681.087 15681.087 0 0185.334-27.5c30.274-9.667 52.73-16.833 67.368-21.5l19.961-19c63.876-63.334 120.598-119.5 170.168-168.5 49.57-49 91.654-90.666 126.253-125 34.6-34.334 61.713-61.167 81.341-80.5 19.629-19.333 31.439-31.333 35.431-36z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgEditPencilSquare, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;